var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighroller(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 3.46875C16.75 4.09766 16.2578 4.5625 15.6562 4.5625C15.6289 4.5625 15.6289 4.5625 15.6289 4.5625L14.2344 12.1641C14.1797 12.5742 13.7969 12.875 13.3867 12.875H4.33594C3.92578 12.875 3.54297 12.5742 3.48828 12.1641L2.09375 4.5625C2.09375 4.5625 2.09375 4.5625 2.06641 4.5625C1.46484 4.5625 0.972656 4.09766 0.972656 3.46875C0.972656 2.86719 1.46484 2.375 2.06641 2.375C2.64062 2.375 3.16016 2.86719 3.16016 3.46875C3.16016 3.71484 3.05078 3.93359 2.91406 4.125L5.375 6.09375C5.8125 6.42188 6.44141 6.28516 6.6875 5.79297L8.27344 2.64844C7.97266 2.45703 7.75391 2.12891 7.75391 1.71875C7.75391 1.11719 8.24609 0.625 8.875 0.625C9.47656 0.625 9.94141 1.11719 9.94141 1.71875C9.94141 2.12891 9.72266 2.45703 9.39453 2.64844L10.9805 5.79297C11.2266 6.28516 11.8828 6.42188 12.3203 6.09375L14.7539 4.125C14.6445 3.93359 14.5625 3.71484 14.5625 3.46875C14.5625 2.86719 15.0273 2.375 15.6562 2.375C16.2578 2.375 16.75 2.86719 16.75 3.46875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighroller);
export default __webpack_public_path__ + "static/media/highroller.dc77aad260522e3a1ff86cbc2cddb246.svg";
export { ForwardRef as ReactComponent };